import React from "react";
import type { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import AlarmPackagesPage from "../pages/alarm-packages/page";
import CameraPackagesPage from "../pages/camera-packages/page";
import AccessControlPage from "../pages/access-control/page";
import LiveMonitoringPage from "../pages/live-monitoring/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import ServiceAreasPage from "../pages/service-areas/page";
import TorontoServiceAreaPage from "../pages/service-areas/toronto/page";
import MississaugaServiceAreaPage from "../pages/service-areas/mississauga/page";
import BramptonServiceAreaPage from "../pages/service-areas/brampton/page";
import OakvilleServiceAreaPage from "../pages/service-areas/oakville/page";
import HamiltonServiceAreaPage from "../pages/service-areas/hamilton/page";
import RichmondHillServiceAreaPage from "../pages/service-areas/richmond-hill/page";
import VaughanServiceAreaPage from "../pages/service-areas/vaughan/page";
import WhitbyServiceAreaPage from "../pages/service-areas/whitby/page";
import AjaxServiceAreaPage from "../pages/service-areas/ajax/page";
import OshawaServiceAreaPage from "../pages/service-areas/oshawa/page";
import FaqPage from "../pages/faq/page";
import ClientsPage from "../pages/clients/page";
import ContactPage from "../pages/contact/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/[slug]/page";
import BusinessSecurityPage from "../pages/business-security/page";
import CommercialSecurityHubPage from "../pages/commercial-security/page";
import CommercialSecurityServiceAreasPage from "../pages/commercial-security/service-areas/page";
import FreeQuotePage from "../pages/free-quote/page";
import GetQuotePage from "../pages/get-quote/page";
import AlarmPromoPage from "../pages/alarm-promo/page";
import CityQuotePage from "../pages/quote/page";
import QuoteThankYouPage from "../pages/quote/thank-you/page";
import NotFound from "../pages/NotFound";
import SitemapPage from "../pages/sitemap/page";
import { lazy } from "react";

const CommercialSecurityServiceAreas = lazy(() => import("../pages/commercial-security/service-areas/page"));
const CommercialSecurityToronto = lazy(() => import("../pages/commercial-security/toronto/page"));
const CommercialSecurityMississauga = lazy(() => import("../pages/commercial-security/mississauga/page"));
const CommercialSecurityBrampton = lazy(() => import("../pages/commercial-security/brampton/page"));
const CommercialSecurityOakville = lazy(() => import("../pages/commercial-security/oakville/page"));
const CommercialSecurityHamilton = lazy(() => import("../pages/commercial-security/hamilton/page"));
const CommercialSecurityRichmondHill = lazy(() => import("../pages/commercial-security/richmond-hill/page"));
const CommercialSecurityVaughan = lazy(() => import("../pages/commercial-security/vaughan/page"));
const CommercialSecurityWhitby = lazy(() => import("../pages/commercial-security/whitby/page"));
const CommercialSecurityAjax = lazy(() => import("../pages/commercial-security/ajax/page"));
const CommercialSecurityOshawa = lazy(() => import("../pages/commercial-security/oshawa/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/alarm-packages",
    element: <AlarmPackagesPage />,
  },
  {
    path: "/camera-packages",
    element: <CameraPackagesPage />,
  },
  {
    path: "/access-control",
    element: <AccessControlPage />,
  },
  {
    path: "/live-monitoring",
    element: <LiveMonitoringPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/free-quote",
    element: <FreeQuotePage />,
  },
  {
    path: "/get-quote",
    element: <GetQuotePage />,
  },
  {
    path: "/quote/thank-you",
    element: <QuoteThankYouPage />,
  },
  {
    path: "/quote",
    element: <CityQuotePage />,
  },
  {
    path: "/alarm-promo",
    element: <AlarmPromoPage />,
  },
  {
    path: "/service-areas",
    element: <ServiceAreasPage />,
  },
  {
    path: "/service-areas/toronto",
    element: <TorontoServiceAreaPage />,
  },
  {
    path: "/service-areas/mississauga",
    element: <MississaugaServiceAreaPage />,
  },
  {
    path: "/service-areas/brampton",
    element: <BramptonServiceAreaPage />,
  },
  {
    path: "/service-areas/oakville",
    element: <OakvilleServiceAreaPage />,
  },
  {
    path: "/service-areas/hamilton",
    element: <HamiltonServiceAreaPage />,
  },
  {
    path: "/service-areas/richmond-hill",
    element: <RichmondHillServiceAreaPage />,
  },
  {
    path: "/service-areas/vaughan",
    element: <VaughanServiceAreaPage />,
  },
  {
    path: "/service-areas/whitby",
    element: <WhitbyServiceAreaPage />,
  },
  {
    path: "/service-areas/ajax",
    element: <AjaxServiceAreaPage />,
  },
  {
    path: "/service-areas/oshawa",
    element: <OshawaServiceAreaPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/clients",
    element: <ClientsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/business-security",
    element: <BusinessSecurityPage />,
  },
  {
    path: "/commercial-security",
    element: <CommercialSecurityHubPage />,
  },
  {
    path: "/commercial-security/service-areas",
    element: <CommercialSecurityServiceAreas />,
  },
  {
    path: "/commercial-security/toronto",
    element: <CommercialSecurityToronto />,
  },
  {
    path: "/commercial-security/mississauga",
    element: <CommercialSecurityMississauga />,
  },
  {
    path: "/commercial-security/brampton",
    element: <CommercialSecurityBrampton />,
  },
  {
    path: "/commercial-security/oakville",
    element: <CommercialSecurityOakville />,
  },
  {
    path: "/commercial-security/hamilton",
    element: <CommercialSecurityHamilton />,
  },
  {
    path: "/commercial-security/richmond-hill",
    element: <CommercialSecurityRichmondHill />,
  },
  {
    path: "/commercial-security/vaughan",
    element: <CommercialSecurityVaughan />,
  },
  {
    path: "/commercial-security/whitby",
    element: <CommercialSecurityWhitby />,
  },
  {
    path: "/commercial-security/ajax",
    element: <CommercialSecurityAjax />,
  },
  {
    path: "/commercial-security/oshawa",
    element: <CommercialSecurityOshawa />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
